import { FC } from 'react';

import lang from '../../lib/language';

import PoweredByLogo from '../../assets/img/powered_by_logo.svg';
import config from '../../config';

import styles from './PoweredBy.module.scss';

type Props = {
  display: boolean;
};

const PoweredBy: FC<Props> = ({ display }: Props): JSX.Element => {
  if (!display) {
    return <></>;
  }

  return (
    <div className={styles.footer}>
      <a href={config.links.alaricUrl} className={styles.content} target="_blank" rel="noopener noreferrer">
        <span className={styles.poweredByText}>{lang.commonPoweredBy()}</span>
        <img src={PoweredByLogo} alt="logo" className={styles.logo} />
      </a>
      <span className={styles.trademarkText}>Trademark of Alaric Securities</span>
    </div>
  );
};

export default PoweredBy;
